export const sitecoreDeveloperDocumentationQuickAction = {
  type: 'ui',
  name: 'Sitecore Developer Portal',
  displayName: { name: 'Resources for the best developer experience' },
  icon: {
    type: 'mdi',
    src: 'mdiForumOutline',
  },
  color: 'gray',
  link: {
    type: 'external-link',
    to: 'https://developers.sitecore.com?utm_source=cloud-portal&utm_medium=help-section',
  },
};
